module.exports = __webpack_public_path__ + "img/GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle1200dia.cd21cc7d.png";